import type { LogoutFlow } from '@ory/client';

import { oryKratosClient } from '../ory-kratos.client';

import { type ServiceResponse } from './types';

export const logoutService = {
  /**
   * ログアウトフローを初期化
   *
   * @param options - オプション
   * @param options.returnTo - ログアウト成功後のリダイレクト先URL
   * @returns ログアウトフロー情報
   *
   * @example
   * ```ts
   * const flow = await logoutService.initFlow();
   * // flow.logout_url にリダイレクトするか、submitFlow()を呼び出す
   * ```
   */
  async initFlow(options?: { returnTo?: string }): Promise<LogoutFlow> {
    const { data } = await oryKratosClient.getApi().createBrowserLogoutFlow({
      returnTo: options?.returnTo,
    });

    if (!data) {
      throw new Error('Failed to create logout flow');
    }

    return data;
  },

  /**
   * ログアウトフローを送信（ログアウト実行）
   *
   * @param token - ログアウトトークン（ログアウトフローから取得）
   * @returns ログアウト結果
   *
   * @example
   * ```ts
   * const flow = await logoutService.initFlow();
   * const result = await logoutService.submitFlow(flow.logout_token);
   *
   * if (result.error) {
   *   console.error(result.error);
   * } else {
   *   // ログアウト成功
   * }
   * ```
   */
  async submitFlow(token: string): Promise<ServiceResponse<void>> {
    try {
      await oryKratosClient.getApi().updateLogoutFlow({ token });
      return { data: null, error: null }; // 成功 (200)
    } catch (err) {
      // ログアウトは通常エラーにならないが、念のため
      return { data: null, error: err as Error };
    }
  },
};
